import { getActionsIsLoadingData, getBadgesByProduct } from '@app/entities/Actions';
import { ElementIdTab, FullProductSpecsAsync, productActions } from '@app/entities/Product';
import { ProductSpecCode } from '@app/entities/Product/module/types/productSchema';
import { useAppDispatch, useAppSelector } from '@app/redux/hooks';
import { StickersCode } from '@app/shared/const/stickers';
import { useEffect } from 'react';

export const FullProductSpecsBlock = () => {
  const stickers = useAppSelector(getBadgesByProduct);
  const isLoading = useAppSelector(getActionsIsLoadingData);
  const dispatch = useAppDispatch();

  useEffect(() => {
    const isWarranty = stickers?.some(sticker =>
      Object.values(StickersCode)
        .filter(x => ![StickersCode.FreeTireFitting, StickersCode.Storage].includes(x))
        .includes(sticker.code as StickersCode),
    );

    if (!isLoading) {
      dispatch(
        productActions.setSpecProduct({
          code: ProductSpecCode.ExtendedWarranty,
          title: 'Расширенная гарантия',
          value: isWarranty ? 'Расширенная гарантия' : 'Стандартная заводская',
          href: isWarranty ? '/garantii#extended' : '/garantii#standard',
          loading: false,
        }),
      );
    }
  }, [stickers, isLoading]);

  return (
    <div id={ElementIdTab.TabProductSpecs}>
      <FullProductSpecsAsync />
    </div>
  );
};
